/* class decorator */
export function staticImplements() {
    return (constructor) => {
        constructor;
    };
}
//# sourceMappingURL=IQueryParser.js.map